import { hasCapability, type User } from "../base";

// The capability is the role half of the gate; recording also requires Contractor team membership, which lives
// in PersonGroup rather than in roles, so TRAINING_SERVICE checks it.
export const contractorTraining = {
  record: (user: User) => hasCapability(user, "contractorTraining.record"),
};
